import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "security-footer-container"
}
const _hoisted_2 = { class: "security-footer-inner" }
const _hoisted_3 = { class: "security-footer-copy" }
const _hoisted_4 = {
  key: 0,
  class: "security-footer-title"
}
const _hoisted_5 = {
  key: 1,
  class: "security-footer-body"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "security-footer-icons",
  "aria-label": "Accepted payment options"
}
const _hoisted_8 = ["src", "alt"]

import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IPaymentSecurityFooterOptions } from '@/interfaces/forms/payment-security-footer.interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSecurityFooter',
  props: {
    paymentOptions: {}
  },
  setup(__props: any) {

const props = __props;

const hasContent = computed(() =>
  Boolean(
    props.paymentOptions?.title?.value || props.paymentOptions?.body?.value || props.paymentOptions?.options?.length
  )
);

return (_ctx: any,_cache: any) => {
  return (hasContent.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.paymentOptions?.title?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "security-footer-icon bg-shield-icon" }, null, -1)),
                  _createVNode(_unref(RichText), {
                    field: _ctx.paymentOptions.title
                  }, null, 8, ["field"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentOptions?.body?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(RichText), {
                    field: _ctx.paymentOptions.body
                  }, null, 8, ["field"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.paymentOptions?.options?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentOptions.options, (option) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: option.type
                    }, [
                      _createElementVNode("img", {
                        src: option.src,
                        alt: option.label,
                        class: _normalizeClass(option.className)
                      }, null, 10, _hoisted_8)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})